import { render } from "./p-draggable-tree.vue?vue&type=template&id=297cff42"
import script from "./p-draggable-tree.vue?vue&type=script&lang=js"
export * from "./p-draggable-tree.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__